import httpRequest from '@/infra/httpRequest';
import GetSaleDTO from '@/application/dto/admin/sales/GetSaleDTO';
import fileDownload from 'js-file-download';
import SearchFilter from '../SearchFilter';

//TODO: Rafatorar
interface ResultPaginationInterface {
    data: GetSaleDTO[];
    perPage: number;
    total: number;
}

export default class SalesRepository {
    public async search(filter: SearchFilter): Promise<ResultPaginationInterface> {
        try {

            const { data: { data, per_page, total } } = await httpRequest.get(`/admin/sales?${filter.getQuery()}`);

            return {
                data: data.map((sale: any) => new GetSaleDTO(
                    sale.id,
                    sale.company_name,
                    { name: sale.customer_name, email: sale.customer_email },
                    sale.page_name,
                    {
                        transaction: sale.external_id,
                        method: sale.payment_method,
                        status: sale.payment_status,
                        amount: sale.amount,
                        createdAt: sale.created_at
                    },
                    { name: sale.product_name, description: sale.product_description, image: sale.product_image }
                )),
                perPage: per_page,
                total,
            }
        } catch (err) {
            throw Error;
        }
    }

    public async exportCsv(filter: SearchFilter): Promise<any> {
        try {
            const resp = await httpRequest.get(`/admin/sales/export/csv?${filter.getQuery()}`);

            const time = new Date().getTime();

            fileDownload(resp.data, `primpass-mkt-vendas-${time}.csv`);
        } catch (err) {
            throw Error;
        }
    }

    public async getInvoincing(filter: SearchFilter): Promise<{ totalCount: number, totalAmount: number }> {
        try {
            const { data: { sales_invoicing } } = await httpRequest.get(`/admin/sales/invoicing?${filter.getQuery()}`);

            return {
                totalAmount: sales_invoicing.total_amount,
                totalCount: sales_invoicing.total_count,
            }
        } catch (err) {
            throw Error;
        }
    }
}